import { transientSession } from "@/utils/preferences";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const sentEvents = new Set();

export const createCtaRequestId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  if (window.crypto?.getRandomValues) {
    const values = new Uint32Array(2);
    window.crypto.getRandomValues(values);
    return `cta-${Date.now()}-${values[0].toString(36)}${values[1].toString(36)}`;
  }
  return `cta-${Date.now()}-${Math.floor(window.performance.now() * 1000)}`;
};

export const trackListingCta = (listingId, action, placement, channel = null) => {
  const dedupeKey = `iwc-cta:${listingId}:${action}:${placement}:${channel || "none"}`;
  if (sentEvents.has(dedupeKey)) return;
  if (transientSession.get(dedupeKey)) return;
  transientSession.set(dedupeKey, "1");
  sentEvents.add(dedupeKey);
  const body = JSON.stringify({
    listingId,
    action,
    placement,
    channel,
    requestId: createCtaRequestId(),
  });
  fetch(`${API}/listing-cta-events`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
    credentials: "omit",
  }).catch(() => {});
};